import apiClient from "../helper/apiClient";
import { get } from "lodash";
import { validateUserKey } from "./validateUserKey";

export default async function getDispositionData(requestObject) {
  validateUserKey(requestObject.userKey);
  try {
    const { data } = await apiClient.get("api/getDispositionMessages", {
      params: requestObject,
    });
    const dispositionData = get(data, "data", []);
    return dispositionData;
  } catch (err) {
    throw new Error(err.message || err);
  }
}
